export default __webpack_public_path__ + "static/media/loginSvgBelobank.3c756ba6.svg";